// @flow
import React, { Component } from 'react';
import { Button, Form, FormGroup, Row, Col } from 'react-bootstrap';

// import api from '../../../../services/api';
import ContactInput from './components/ContactInput/ContactInput';
import locale from '../../../../locales/index';
import style from './components/ContactInput/style';

class Calling extends Component<{
  user: Object,
}, {
  contacts: Array<Object>,
  // users: Array<Object>,
}> {
  constructor(props: Object) {
    super(props);
    const settings = this.props.user.modules.calling || {};

    this.state = {
      contacts: (settings.contacts) ? settings.contacts : [],
      // users: [],
    };
  }

  componentWillMount() {
    this.keys = this.state.contacts.map((e, index) => (index.toString()));
  }

  save(user: Object): Object {
    const newUser = user;
    const contact = this.state.contacts.filter(e => (e.email.length > 0) && (e.name.length > 0));
    newUser.modules.calling.contacts = contact;
    return newUser;
  }

  addContact() {
    const newList = this.state.contacts;
    newList.push({ name: '', email: '', picture: false });
    this.keys.push(((new Date()).getTime()).toString());
    this.setState({ contacts: newList });
  }

  remove(index: number) {
    const newList = this.state.contacts;
    newList.splice(index, 1);
    this.keys.splice(index, 1);
    this.setState({ contacts: newList });
  }

  contactChanged(val: Object, index: number) {
    const newList = this.state.contacts;
    newList[index] = val;
    this.setState({ contacts: newList });
  }

  keys: Array<string>

  generateFields(): Array<Object> {
    return (this.state.contacts.map((contact, index) => (<ContactInput
      contact={contact}
      onRemove={() => this.remove(index)}
      key={this.keys[index]}
      onChange={e => this.contactChanged(e, index)}
      // users={this.state.users}
    />)));
  }

  render() {
    return (<div>
      <h4>{locale.calling}</h4>
      <Form horizontal>
        <FormGroup controlId="formHorizontalEmail">
          <Row style={style.container}>
            <Col sm={1} style={style.col} />
            <Col sm={11} style={style.col}>
              <h5>{locale.callContacts}</h5>
            </Col>
          </Row>
          <Row style={style.container}>
            <Col sm={2} style={style.col} />
            <Col sm={4} style={style.col}>
              <h5>{locale.contactMail}</h5>
            </Col>
            <Col sm={3} style={style.col}>
              <h5>{locale.contactName}</h5>
            </Col>
            <Col sm={3} style={style.col}>
              <h5>{locale.contactPicture}</h5>
            </Col>
          </Row>
          {/* <Col componentClass={ControlLabel} sm={2}>
            {locale.callContacts}
          </Col> */}
          <Col sm={12}>
            {this.generateFields()}
            <span>
              <Button onClick={() => this.addContact()} bsStyle="primary">{locale.add}</Button>
            </span>
          </Col>
        </FormGroup>
      </Form>
    </div>);
  }
}

export default Calling;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/Calling/Calling.js